<template>
  <div>
    <b-input
      v-model="credentials.name"
      :error-messages="getErrorMessages(v$.name)"
      density="compact"
      label="Назва ролі"
      placeholder="введіть назву"
      variant="outlined"></b-input>
    <b-input
      v-model="credentials.description"
      density="compact"
      label="Опис"
      placeholder="введіть опис"
      variant="outlined"></b-input>
  </div>
</template>

<script>
import { reactive } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { getErrorMessages } from 'best-modules/utils'
import { roleCreate, roleUpdate } from '@/requests/role'

export default {
  name: 'RoleDialog',
  props: {
    dialog: { type: Object, required: true },
  },
  methods: { getErrorMessages },
  setup(props) {
    const roleData = props.dialog.dialogData?.roleData || {}

    const credentials = reactive({
      name: roleData.name || '',
      description: roleData.description || '',
    })

    const v$ = useVuelidate(
      {
        name: { required },
      },
      credentials
    )

    const submit = () => {
      const isUpdate = props.dialog.action === 'update'
      return isUpdate
        ? roleUpdate(roleData.id, credentials)
        : roleCreate(credentials)
    }

    return { credentials, v$, submit }
  },
}
</script>
